<template>
    <div style="padding: 20px;position: relative;">
        <a-modal title="导入" :visible="dialog" :footer="null" @cancel="dialog=false">
            <span>
                <input ref="upload" style="display: none" type="file" @change="onUpload" />

                <a-button :loading="loading" @click="onClick" style="margin-right: 10px;"
                >导入</a-button>
                <a href="javacript:void(0)" @click="download">下载模板</a>
            </span>
        </a-modal>
        <a-modal title="金额编辑" :visible="editDialog" :footer="null" @cancel="editDialog=false" width="300px">
            <div style="font-size: 14px;font-weight: bold;">咨询设计类:</div>
            <div class="form-item">
                <span>总院预计调整额：</span>
                <a-input-number v-model="editMoney.prodProjectPreChangeAmount" placeholder="请输入金额"></a-input-number>
            </div>
            <div class="form-item">
                <span>分院预计调整额：</span>
                <a-input-number v-model="editMoney.branchProjectPreChangeAmount " placeholder="请输入金额"></a-input-number>
            </div>
            <div style="font-size: 14px;margin-top: 20px;font-weight: bold;">总承包类:</div>
            <div class="form-item">
                <span>已确认进度收入：</span>
                <a-input-number v-model="editMoney.zcbProjectAmount" placeholder="请输入金额"></a-input-number>
            </div>
            <div class="form-item">
                <span>已调整进度收入：</span>
                <a-input-number v-model="editMoney.zcbProjectChangeAmount" placeholder="请输入金额"></a-input-number>
            </div>
            <div class="form-item">
                <span>合同资产：</span>
                <a-input-number v-model="editMoney.zcbContractAssets" placeholder="请输入金额"></a-input-number>
            </div>
            <div class="form-item">
                <span>应收-已开票未回款：</span>
                <a-input-number v-model="editMoney.zcbReceivableInvNotPay" placeholder="请输入金额"></a-input-number>
            </div>
            <div class="form-item">
                <span>应收-未开票：</span>
                <a-input-number v-model="editMoney.zcbReceivableNotInv" placeholder="请输入金额"></a-input-number>
            </div>
            <div class="form-item">
                <span>已开票已回款：</span>
                <a-input-number v-model="editMoney.zcbReceivableInvPay" placeholder="请输入金额"></a-input-number>
            </div>
            <div class="form-item">
                <span>预计调整额：</span>
                <a-input-number v-model="editMoney.zcbProjectPreChangeAmount" placeholder="请输入金额"></a-input-number>
            </div>
            <div style="margin-top: 20px;">
                <a-button type="primary" @click="changeAmountSave">保存</a-button>
            </div>
        </a-modal>
        <a-modal title="合同台账" :visible="contractDialog" :footer="null" @cancel="contractDialog=false" width="70%">
            <div style="display: flex;margin-bottom: 10px;">
                <ContractSelector
                    style="width: 200px;margin-right: 10px;"
                    @change="onSelectContract"
                >
                    <a-button style="text-align: left" class="text-hidden" block>
                    <span v-if="selectedContract.name">{{
                        selectedContract.name
                    }}</span>
                    <span v-else>&nbsp;</span>
                    </a-button>
                </ContractSelector>
                <a-space>
                    <a-button @click="query" type="primary">查询</a-button>
                    <a-button @click="cancelSelectContract">重置</a-button>
                </a-space>
            </div>
            <a-table bordered :dataSource="contractList" @change="onChange" :pagination="{
                          total,
                          current,
                          pageSize,
                          showTotal: (total) => `共 ${total} 条记录`,
                        }">
                <a-table-column title="合同名称">
                    <template slot-scope="text, record, index">
                        {{ text.contract.name }}
                    </template>
                </a-table-column>
                <a-table-column data-index="accountsReceivable" title="应收账款(万元)"></a-table-column>
                <a-table-column data-index="contractAssets" title="合同资产(万元)"></a-table-column>
                <a-table-column data-index="projectAmount" title="进度收入(万元)"></a-table-column>
                <a-table-column data-index="receivableInvNotPay" title="已开票未回款(万元)"></a-table-column>
                <a-table-column data-index="receivableInvPay" title="已开票已回款(万元)"></a-table-column>
                <a-table-column data-index="receivableNotInv" title="未开票(万元)"></a-table-column>
            </a-table>
        </a-modal>
        
        <div style="display: flex;" class="topCard">
            <div class="card">
                <div class="title">合同资产、应收账款总览</div>
                <div class="content" style="padding-left:0;margin-left:0;">
                    <div class="header" style="width:50%;margin-left:20px">
                        <div class="item">
                            <span>合同资产</span>
                            <span class="num">{{result.contractAssets}}</span>
                            <span class="unit">万元</span>
                        </div>
                        <div class="item">
                            <span>应收账款</span>
                            <span class="num">{{result.accountsReceivable}}</span>
                            <span class="unit">万元</span>
                        </div>    
                    </div>
                    <a-button type="primary" @click="editDialog=true" style="margin-right: 10px;float: right;">金额编辑</a-button>
                    <a-button type="primary" @click="contractDialog=true" style="margin-right: 10px;float: right;">合同台账</a-button>
                    <a-button type="primary" @click="dialog=true" style="margin-right: 10px;float: right;">导入发票回款</a-button>
                </div>
                
            </div>
        </div>
        <div style="display: flex;margin-top: 20px;">
            <div class="card" style="width: 50%;margin-right: 20px;">
                <div class="subTitle">咨询设计类</div>
                <div class="header" style="padding: 0 80px">
                    
                    <div class="item">
                        <span>合同资产</span>
                        <span class="num">{{result.sjContractAssets}}</span>
                        <span class="unit">万元</span>
                    </div>
                    <div class="item">
                        <span>应收账款</span>
                        <span class="num">{{result.sjAccountsReceivable}}</span>
                        <span class="unit">万元</span>
                    </div>    
                </div>
                <div class="content">
                    <div class="thead">
                        <div class="th">
                            已确认进度收入
                        </div>
                        <div class="th">
                            已调整进度收入
                        </div>
                        <div class="th">
                            合同资产
                        </div>
                        <div class="th">
                            应收-已开票未回款
                        </div>
                        <div class="th">
                            应收-未开票
                        </div>
                        <div class="th">
                            已开票已回款
                        </div>
                        <div class="th">
                            预计调整额
                        </div>
                    </div>
                    <div class="tbody">
                        <div class="tr">
                            <div class="title">
                                总院
                            </div>
                            <div class="td">
                                {{result.prodProjectAmount}}
                            </div>
                            <div class="td">
                                {{result.prodProjectChangeAmount}}
                            </div>
                            <div class="td">
                                {{result.prodContractAssets}}
                            </div>
                            <div class="td">
                                {{result.prodReceivableInvNotPay}}
                            </div>
                            <div class="td">
                                {{result.prodReceivableNotInv}}
                            </div>
                            <div class="td">
                                {{result.prodReceivableInvPay}}
                            </div>
                            <div class="td">
                                {{result.prodProjectPreChangeAmount}}
                            </div>
                        </div>
                        <div class="tr">
                            <div class="title">
                                分院
                            </div>
                            <div class="td">
                                {{result.branchProjectAmount}}
                            </div>
                            <div class="td">
                                {{result.branchProjectChangeAmount}}
                            </div>
                            <div class="td">
                                {{result.branchContractAssets}}
                            </div>
                            <div class="td">
                                {{result.branchReceivableInvNotPay}}
                            </div>
                            <div class="td">
                                {{result.branchReceivableNotInv}}
                            </div>
                            <div class="td">
                                {{result.branchReceivableInvPay}}
                            </div>
                            <div class="td">
                                {{result.branchProjectPreChangeAmount}}
                            </div>
                        </div>
                    </div>    
                </div>
            </div>
            <div class="card" style="width: 50%;">
                <div class="subTitle">总承包类</div>
                <div class="header" style="padding: 0 80px">
                    
                    <div class="item">
                        <span>合同资产</span>
                        <span class="num">{{result.zcbContractAssets}}</span>
                        <span class="unit">万元</span>
                    </div>
                    <div class="item">
                        <span>应收账款</span>
                        <span class="num">{{result.zcbAccountsReceivable}}</span>
                        <span class="unit">万元</span>
                    </div>    
                </div>
                <div class="content">
                    <div class="thead">
                        <div class="th">
                            已确认进度收入
                        </div>
                        <div class="th">
                            已调整进度收入
                        </div>
                        <div class="th">
                            合同资产
                        </div>
                        <div class="th">
                            应收-已开票未回款
                        </div>
                        <div class="th">
                            应收-未开票
                        </div>
                        <div class="th">
                            已开票已回款
                        </div>
                        <div class="th">
                            预计调整额
                        </div>
                    </div>
                    <div class="tbody">
                        <div class="tr">
                            <div class="title">
                                总承包
                            </div>
                            <div class="td">
                                {{result.zcbProjectAmount}}
                            </div>
                            <div class="td">
                                {{result.zcbProjectChangeAmount}}
                            </div>
                            <div class="td">
                                {{result.zcbContractAssets}}
                            </div>
                            <div class="td">
                                {{result.zcbReceivableInvNotPay}}
                            </div>
                            <div class="td">
                                {{result.zcbReceivableNotInv}}
                            </div>
                            <div class="td">
                                {{result.zcbReceivableInvPay}}
                            </div>
                            <div class="td">
                                {{result.zcbProjectPreChangeAmount}}
                            </div>
                        </div>
                    </div>    
                </div>
            </div>
        </div>
        <div style="display: flex;margin-top: 20px;">
        <div class="card" style="width: 50%;margin-right: 20px;">
                <div class="title">应收账款月度分布情况</div>
                <a-tabs style="width: 100%;padding: 0 10px;" defaultActiveKey="tab2" @change="tabChange($event,'bar3')">
                    <a-tab-pane tab="表格" key="tab1">
                        <a-table :dataSource="result?.monthList" :pagination="false" :scroll="{ y:210 }">
                            <a-table-column title="月份">
                                <template slot-scope="text, record, index">
                                    {{ text.month }}月
                                </template>
                            </a-table-column>
                            <a-table-column title="总院设计(万元)">
                                <template slot-scope="text, record, index">
                                    <span>{{ text.prodAccountsReceivable }}</span>
                                </template>
                            </a-table-column>
                            <a-table-column title="分院设计(万元)">
                                <template slot-scope="text, record, index">
                                    <span>{{ text.branchAccountsReceivable }}</span>
                                </template>
                            </a-table-column>
                            <a-table-column title="总承包(万元)">
                                <template slot-scope="text, record, index">
                                    <span>{{ text.zcbAccountsReceivable }}</span>
                                </template>
                            </a-table-column>
                        </a-table>
                    </a-tab-pane>
                    <a-tab-pane tab="图例" key="tab2">
                        <div id="bar3" style="width: 100%;height: 240px;"></div>
                    </a-tab-pane>
                </a-tabs>
            </div>
            <div class="card" style="width: 50%;">
                <div class="title">合同资产月度分布情况</div>
                <a-tabs style="width: 100%;padding: 0 10px;" defaultActiveKey="tab2" @change="tabChange($event,'bar2')">
                    <a-tab-pane tab="表格" key="tab1">
                        <a-table :dataSource="result?.monthList" :pagination="false" :scroll="{ y:210 }">
                            <a-table-column title="月份">
                                <template slot-scope="text, record, index">
                                    {{ text.month }}月
                                </template>
                            </a-table-column>
                            <a-table-column title="总院设计(万元)">
                                <template slot-scope="text, record, index">
                                    <span>{{ text.prodContractAssets }}</span>
                                </template>
                            </a-table-column>
                            <a-table-column title="分院设计(万元)">
                                <template slot-scope="text, record, index">
                                    <span>{{ text.branchContractAssets }}</span>
                                </template>
                            </a-table-column>
                            <a-table-column title="总承包(万元)">
                                <template slot-scope="text, record, index">
                                    <span>{{ text.zcbContractAssets }}</span>
                                </template>
                            </a-table-column>
                        </a-table>
                    </a-tab-pane>
                    <a-tab-pane tab="图例" key="tab2">
                        <div id="bar2" style="width: 100%;height: 240px;"></div>
                    </a-tab-pane>
                </a-tabs>
            </div>
            
        </div>
    </div>
</template>

<script>
import scrollPicker from "@/components/scroll-picker";
import {formatAmount} from "@/utils/dataBoard"
import * as echarts from "echarts/core";
import request from "@/api/request";
import download from '@/api/download'
import { saveAs } from "file-saver";
import {
    TooltipComponent,
    GridComponent,
    LegendComponent,
} from "echarts/components";
import { BarChart, LineChart, PieChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import ContractSelector from "@/components/contract-selector";
function fetchContractList(params) {
    return request({
        url: "project-service/dsContractAssets/contractList",
        params
    });
}
function fetchList(year) {
    return request({
        url: "project-service/dsContractAssets/data",
    });
}
function fetchByMonth(year, month) {
    return request({
        url: "project-service/dsContract/month/" + year + "/" + month,
    });
}
function fetchInfo(year,type) {
    return request({
        url: "project-service/dsContract/total/dept/" + year + "/" + type,
    });
}
function getTemplate() {
  return download({
    url: "/project-service/dsContractAssets/importInvTemp",
  });
}
function importChangeList(data) {
    return request({
        url: "project-service/dsContractAssets/importInv",
        method: 'post',
        data
    });
}
function amountSave(params) {
    return request({
        url: "project-service/dsContractAssets/update/data",
        method: 'get',
        params
    });
}
echarts.use([
    TooltipComponent,
    GridComponent,
    LegendComponent,
    BarChart,
    LineChart,
    PieChart,
    CanvasRenderer,
]);
export default {
    data() {
        return {
            editDialog: false,
            selectedContract: {},
            current: 1,
            pageSize: 10,
            contractId: '',
            contractList: [],
            total: 0,
            contractDialog: false,
            dialog: false,
            editMoney: {},
            result: {},
            title: '',
            tableList: [],
            dialogShow: false,
            color: ['#5E92FF', '#3CCD92', '#FFDE59', '#EA7D54'],
            targetInfo: {
                percentA: '',
                percentB: '',
                percentC: '',
                percentD: '',
            },
            year: 0,
            yearList: [],
            monthList: [],
            lastMonth: '',
            pieInfo:{},
            loading: false,
        };
    },
    components:{
        scrollPicker,
        ContractSelector
    },
    mounted() {
        this.getYearList()
        this.getMonthList()
        this.getData()
        this.getContractList()
    },

    methods: {
        changeAmountSave(){

            amountSave({
                id: this.editMoney.id,
                prodProjectPreChangeAmount: this.editMoney.prodProjectPreChangeAmount * 10000,
                branchProjectPreChangeAmount: this.editMoney.branchProjectPreChangeAmount * 10000,
                zcbProjectAmount: this.editMoney.zcbProjectAmount * 10000,
                zcbProjectChangeAmount: this.editMoney.zcbProjectChangeAmount * 10000,
                zcbContractAssets: this.editMoney.zcbContractAssets * 10000,
                zcbReceivableInvNotPay: this.editMoney.zcbReceivableInvNotPay * 10000,
                zcbReceivableNotInv: this.editMoney.zcbReceivableNotInv * 10000,
                zcbReceivableInvPay: this.editMoney.zcbReceivableInvPay * 10000,
                zcbProjectPreChangeAmount: this.editMoney.zcbProjectPreChangeAmount * 10000,
            }).then(() => {
                this.editDialog = false;
                this.getData()
            })
        },
        query(){
            this.current = 1
            this.getContractList();
        },
        onSelectContract(obj) {
            console.log("obj", obj);
            this.selectedContract = obj;
        },
        cancelSelectContract() {
            this.selectedContract = {};
            this.current = 1
            this.getContractList();
        },
        onChange(pagination) {
            this.current = pagination.current;
            this.getContractList();
        },
        getContractList() {
            fetchContractList({
                contractId: this.selectedContract.id,
                pageNum: this.current,
                pageSize: this.pageSize
            }).then(res => {
                if (res && Array.isArray(res.list)) {
                    this.contractList = res.list;
                    this.total = res.totalSize;
                }
            })
        },
        download(){
            getTemplate().then(blob=>{
                saveAs(blob, "导出结果.xlsx");
            })
        },
        onClick(){
            this.$refs.upload.click();
        },
        onUpload(e) {
            console.log(e)
            const files = e.target.files;
            const data = new FormData();
            for (let i = 0; i < files.length; i++) {
                data.append("file", files[i]);
            }

            this.loading = true;

            importChangeList(data)
                .then(() => {
                })
                .finally(() => {
                    this.loading = false;
                    e.target.value = null;
                    this.dialog = false;
                    this.getData()
                });
        },
        tabChange(e, type) {
            if(e == 'tab2') {
                this.$nextTick(()=>{
                    if(type == 'bar2'){
                        this.renderYearHisData(this.result.monthList)
                    } else{
                        this.renderMonthHisData(this.result.monthList)
                    }
                    
                })
                
            }
        },
        getData() {
            fetchList(this.year).then(res => {
                res = formatAmount(res)
                this.result = res
                this.editMoney = JSON.parse(JSON.stringify(res))
                this.renderYearHisData(this.result.monthList)
                this.renderMonthHisData(this.result.monthList)

            })
        },

        getYearList() {
            const now = new Date().getFullYear()
            console.log(now)
            for (let index = 2021; index <= now; index++) {
                this.yearList.push(
                    {
                        name: index,
                        value: index
                    }
                )
            }
            this.year = this.yearList[this.yearList.length - 1].value
        },
        getMonthList() {
            for (let index = 1; index <= 12; index++) {
                this.monthList.push(
                    {
                        name: index + '月',
                        value: index
                    }
                )
            }
        },
        yearChange(value) {
            this.year = value
            this.getData()
        },
        monthChange(data) {
            fetchByMonth(this.year, data).then(res=>{
                res = formatAmount(res)
                this.renderMonthData(res)
            })
        },
        renderMonthData(data) {
            if (!data) {
                this.lastMonth = ''
                this.bar1 && this.bar1.clear()
                return
            }
            this.lastMonth = data.month
            const $this = this
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {}
                },
                grid: {
                    left: '10%',
                    right: '10%',
                    bottom: '10%',
                    top: '10%',
                    containLabel: true //可容纳
                },
                xAxis: {
                    show: false
                },
                yAxis: [
                    {
                        type: 'category',
                        data: ['总院设计', '分院设计', 'EPC', '智慧类'],   //请求回来的数组y轴数据
                        inverse: true,
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            color: 'black'
                        }
                    },
                    {
                        type: 'category',
                        data: [data.prodUndertakeAmount + '万', data.branchUndertakeAmount + '万', data.epcUndertakeAmount + '万', data.wisdomUndertakeAmount + '万'],
                        inverse: true,
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            textStyle: {
                                fontSize: 12,
                                color: 'black'
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '已承接',
                        type: 'bar',
                        data: [data.prodUndertakeAmount, data.branchUndertakeAmount, data.epcUndertakeAmount, data.wisdomUndertakeAmount],
                        barWidth: 15,
                        itemStyle: {
                            color: function (params) {
                                return $this.color[params.dataIndex];
                            },
                            border: 'none',
                            borderWidth: 3,
                            barBorderRadius: 15
                        }
                    }
                ]
            }
            this.bar1 = echarts.init(document.getElementById("bar1"));
            this.bar1.setOption(option);
        },
        renderYearHisData(data) {
            if (!data) {
                this.bar2 && this.bar2.clear()
                return
            }
            let option = {
                legend: {
                    icon: 'circle',
                    selected: {
                        'EPC':false,
                        '智慧类': false
                    }
                },
                tooltip: {
                    trigger: 'axis',
                },
                xAxis: {
                    type: 'category',
                    data: data.map(v => v.month + '月')
                },
                yAxis: {
                    type: 'value',
                    name: "(万元)",
                },
                series: [{
                    name: '总院设计',
                    color: this.color[0],
                    data: data.map(v => v.prodContractAssets),
                    type: 'line',
                    barGap: '20%',
                    barCategoryGap: '40%',
                    itemStyle: {
                        normal: {
                            barBorderRadius: [50, 50, 0, 0], // 左上，右上，右下，左下
                        }
                    }
                }, {
                    name: '分院设计',
                    color: this.color[1],
                    data: data.map(v => v.branchContractAssets),
                    type: 'line',
                    barGap: '20%',
                    barCategoryGap: '40%',
                    itemStyle: {
                        normal: {
                            barBorderRadius: [50, 50, 0, 0], // 左上，右上，右下，左下
                        }
                    }
                },{
                    name: '总承包',
                    color: this.color[2],
                    data: data.map(v => v.zcbContractAssets),
                    type: 'line',
                    barGap: '20%',
                    barCategoryGap: '40%',
                    itemStyle: {
                        normal: {
                            barBorderRadius: [50, 50, 0, 0], // 左上，右上，右下，左下
                        }
                    }
                }]
            };
            this.bar2 = echarts.init(document.getElementById("bar2"));
            this.bar2.setOption(option);
        },
        renderMonthHisData(data) {
            if (!data) {
                this.bar3 && this.bar3.clear()
                return
            }
            let option = {
                legend: {
                    icon: 'circle',
                    selected: {
                        'EPC':false,
                        '智慧类': false
                    }
                },
                tooltip: {
                    trigger: 'axis',
                },
                xAxis: {
                    type: 'category',
                    data: data.map(v => v.month + '月')
                },
                yAxis: {
                    type: 'value',
                    name: "(万元)",
                },
                series: [{
                    name: '总院设计',
                    color: this.color[0],
                    data: data.map(v => v.prodAccountsReceivable),
                    type: 'line',
                    barGap: '20%',
                    barCategoryGap: '40%',
                    itemStyle: {
                        normal: {
                            barBorderRadius: [50, 50, 0, 0], // 左上，右上，右下，左下
                        }
                    }
                }, {
                    name: '分院设计',
                    color: this.color[1],
                    data: data.map(v => v.branchAccountsReceivable),
                    type: 'line',
                    barGap: '20%',
                    barCategoryGap: '40%',
                    itemStyle: {
                        normal: {
                            barBorderRadius: [50, 50, 0, 0], // 左上，右上，右下，左下
                        }
                    }
                },{
                    name: '总承包',
                    color: this.color[2],
                    data: data.map(v => v.zcbAccountsReceivable),
                    type: 'line',
                    barGap: '20%',
                    barCategoryGap: '40%',
                    itemStyle: {
                        normal: {
                            barBorderRadius: [50, 50, 0, 0], // 左上，右上，右下，左下
                        }
                    }
                }]
            };
            this.bar3 = echarts.init(document.getElementById("bar3"));
            this.bar3.setOption(option);
        },
    }
};
</script>
<style lang="less" scoped>
.topCard{
    
    .card{
        width: 100%;
        padding: 0 20px;
    }
    .content{
        display: flex;
        justify-content: space-between;
        align-items: center;
        
    }
}
.card {
    background: #FFFFFF;
    border-radius: 15px;
    margin-top: 30px;
    position: relative;
    box-shadow: 0px 3px 8px 1px #E4E9F1;
    .subTitle{
        font-size: 18px;
        margin-top: 20px;
        margin-bottom: 10px;
        padding-bottom: 20px;
        border-bottom: 1px solid #E4E9F1;
        text-align: center;
    }
    .header{
        margin:0 auto;
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        padding: 0 40px;
        .item{
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .num{
            font-weight: bold;
            font-size: 28px;
            margin-left: 20px;
        }
        .unit{
            font-size: 12px;
            margin-top:10px;
        }
    }
    .content{
        margin-left: 12%;
        padding: 20px;
        .thead{
            display: flex;
            width: 100%;
            .th{
                flex: 1;
                text-align: center;
                font-size: 12px;
                font-weight: bold;
                padding: 10px 0;
            }
        }
        .tbody{
            width: 100%;
            .tr{
                display: flex;
                width: 100%;
                position: relative;
                .title{
                    display:absolute;
                    left: -60px;
                    top: 8px;
                    font-size: 18px;
                }
                .td{
                    flex: 1;
                    text-align: center;
                    font-size: 14px;
                    padding: 10px 0;
                    border-left: 1px solid #E4E9F1;
                }
            }
        }
    }
}

.item {
    margin-right: 10px;
    text-align: center;
    position: relative;
    .line{
        width: 1px;
        position: absolute;
        height: 328px;
        right: 0;
        bottom: 0;
        background: #ddd;
    }
    .header {
        margin-top: 20px;
        font-size: 16px;

        span {
            cursor: pointer;
        }
    }

    .tip {
        font-size: 12px;
        color: #595959;
        position: absolute;
        top: 64%;
        left: 0;
        right: 0;
        margin: auto;

        .info {
            font-weight: bold;
            font-size: 30px;
        }
    }

    .pie {
        width: 100%;
        height: 200px;
    }
    .legend{
        text-align: left;
        font-size: 14px;
        margin-top: 30px;
        text-align: center;
        span{
            display: inline-block;
            margin-right: 5px;
        }
        .bold{
            font-size: 30px;
            font-weight: bold;
        }
        >div{
            margin-bottom: 5px;
        }
    }
}

.title {
    font-size: 14px;
    position: absolute;
    top: -30px;
    left: 30px;
}
.form-item{
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    span{
        width: 180px;
        text-align: left;
        margin-right: 10px;
        font-size: 14px;
    }
    div{
        width:200px
    }
}
</style>